module.exports = __webpack_public_path__ + "img/coingecko.4d666edd.png";